<template>
  <div class="components-app-switch inline-block cursor-pointer">
    <el-dropdown size="large" class="" @command="clickItem" v-if="appSystemList.length">
      <span class="el-dropdown-link">
        <i class="iconfont icon-yingyongguanli"></i>
        {{ appName }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
        <el-dropdown-item
          v-for="(item, index) in appSystemList"
          :key="index"
          :command="item"
          >{{ item.name }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import userModel from '@/libs/userModel';
export default {
  computed: {
    ...mapState({
      appSystemList: state => state.appSystemList
    })
  },
  data() {
    return {
      appName: ''
    };
  },
  created() {
  },
  mounted() {
    let isLogined = userModel.checkLoginState();
    if (isLogined) {
      this.$store.dispatch('getAppSystemList');
    }
  },
  methods: {
    /**
     *
     * @param item
     */
    clickItem(item) {
      var reg = new RegExp('^' + this.$config.originURL);
      if (reg.test(item.url)) {
        this.$router.push(item.url.replace(this.$config.originURL + '/#', ''));
      } else {
        window.location.href = item.url;
      }
    }
  }
};
</script>
<style lang="scss">
.custom-dropdown-menu{
  max-height: calc(100% - 200px);
  overflow-y: auto;
}
</style>
